import React, {useEffect, useRef, useState} from "react";
import {LanguageLink} from "Components/LanguageBox";
import {Parentmenu} from "./ParentMenu";
import {MainMenu as HamburgerMenu} from "Components/Menu/MainMenu";
import {HeaderMenuItem} from "Components/Menu/HeaderMenuItem";
import {HamburgerButton} from "Components/BurgerButton/HamburgerButton";
import {ButtonText, PrimaryButton} from "BaseComponents/Button";
import useBreakpoint from "Hooks/useBreakpoint";
import {PhoneVolume} from "BaseComponents/Icons/Svg";
import {PublicAnnouncement} from "Components/PublicAnnouncement/PublicAnnouncement";
import {HeaderButtonBookATour} from "Components/HeaderButtonBookATour/HeaderButtonBookATour";

export const Header = ({
                         LogoSrc,
                         LogoUrl,
                         BigLogo,
                         AltText,
                         LoginPageUrl,
                         LoginText,
                         MenuItems,
                         MainMenu,
                         ParentMenu,
                         SearchPageUrl,
                         PublicAnnouncement: CrisisBanner,
                         MainMenuAriaLabel,
                         element,
                         PhoneNumber,
                         PhoneButtonLabel,
                         HideLanguageButton,
                         ShowLanguageButtonAtBottom,
                         ShowHeaderButtons,
                         HeaderButtons,
                         BipText,
                         BipUrl
                       }) => {
  let headerHeight = useRef(0);
  const [isSmallHeader, setIsSmallHeader] = useState(false);
  useEffect(() => {
    if (element != undefined) {
      const clientRect = headerHeight.current.getBoundingClientRect();
      element.style.height = `${clientRect.height}px`;
    }
  }, []);

  useEffect(() => {
    const onScroll = (e) => {
      if (window.scrollY > 400 && !isSmallHeader) {
        setIsSmallHeader(true);
      } else if (window.scrollY <= 400 && isSmallHeader) {
        setIsSmallHeader(false);
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [isSmallHeader]);

  let parentItem = {
    Name: ParentMenu?.NavigationLinkName || ParentMenu?.Headline,
    Url: ParentMenu?.HeadlineUrl,
    Children: ParentMenu?.Links
  };

  return (
    <>
      <div
        ref={headerHeight}
        className={`header-wrapper ${isSmallHeader ? "small-header" : ""}`}
      >
        {ParentMenu != null && ParentMenu != undefined && !ParentMenu?.ShowChildInNavigation && (
          <Parentmenu {...ParentMenu} />
        )}
        <div className="lang-box-wrapper" id="language-field"></div>

        <div className="header-wrapper__top">
          <div className="header-wrapper__top__content">
            <div
              className={`header-wrapper__top__content__logo-wrapper ${
                BigLogo && "big-logo"
              }`}
            >
              {LogoSrc != undefined && (
                <a href={LogoUrl}>
                  <img src={LogoSrc} alt={AltText}></img>
                </a>
              )}
            </div>
            <ul className="header-wrapper__top__content__right">
              {ShowHeaderButtons &&
                HeaderButtons?.length > 0 &&
                HeaderButtons.map((HeaderButton, index) => {
                  return (
                    <li
                      key={index}
                      className={`${
                        HeaderButton.MobileShowInHeader ? "" : "only-desktop"
                      }`}
                    >
                      <HeaderButtonBookATour {...HeaderButton} />
                    </li>
                  );
                })}

              {PhoneNumber.length > 0 && (
                <li>
                  <PrimaryButton
                    className="header__button"
                    width="fit-content"
                    margin="0"
                    padding="0 20px"
                    href={`tel:${PhoneNumber}`}
                    importandPadding={true}
                  >
                    <ButtonText
                      padding="0"
                      margin="0"
                      fontWeight="normal"
                      display="flex"
                      alignItems="center"
                      heading={`phone number ${PhoneNumber}`}
                    >
                      <PhoneVolume margin="0"></PhoneVolume>
                      <ButtonText className="only-desktop" heading={`phone number ${PhoneNumber}`}>
                        {PhoneButtonLabel}
                      </ButtonText>
                    </ButtonText>
                  </PrimaryButton>
                </li>
              )}
              {LoginPageUrl != undefined && (
                <li className="only-desktop">
                  <a
                    target="_blank"
                    className="element-link parent-menu-link "
                    href={LoginPageUrl}
                  >
                    <i className="icon-key" aria-hidden="true"></i>
                    <span>{LoginText}</span>
                  </a>
                </li>
              )}
              {!HideLanguageButton && (
                <li className="only-desktop">
                  <LanguageLink desktop LinkText="language"/>
                </li>
              )}
              {BipUrl != undefined && (
                <li className="only-desktop">
                  <a
                    target="_blank"
                    className="element-link parent-menu-link"
                    href={BipUrl}
                  >
                    <i className="icon-svg-logo-bip"></i>
                    <span>{BipText}</span>
                  </a>
                </li>
              )}
              {SearchPageUrl != undefined && <li id="search-link"></li>}
              {useBreakpoint("ipadPro", "down") && (
                <li>
                  <HamburgerButton/>
                </li>
              )}
            </ul>
          </div>
        </div>
        <div id="search-field"></div>
        <nav aria-label={MainMenuAriaLabel} className="header-wrapper__nav">
          <div className="header-wrapper__nav__content">
            <div className="header-wrapper__nav__content__container">
              {ParentMenu?.ShowChildInNavigation && (
                <div className="header-wrapper__nav__content__container__parent-nav-container">
                  {<HeaderMenuItem item={parentItem}></HeaderMenuItem>}
                </div>
              )}
              {MainMenu?.map((item, i) => {
                return (
                  <div
                    className="header-wrapper__nav__content__container__parent-nav-container"
                    key={`item-menu${i}`}
                  >
                    <HeaderMenuItem item={item}></HeaderMenuItem>
                  </div>
                );
              })}
            </div>
          </div>
        </nav>
        <PublicAnnouncement {...CrisisBanner} />

        {MenuItems != undefined && (
          <HamburgerMenu
            LoginPageUrl={LoginPageUrl}
            ParentMenuLink={ParentMenu != null && ParentMenu?.HeadlineUrl}
            MenuItems={MenuItems}
            LoginText={LoginText}
            PhoneNumber={PhoneNumber}
            PhoneButtonLabel={PhoneButtonLabel}
            HideLanguageButton={HideLanguageButton}
            ShowLanguageButtonAtBottom={ShowLanguageButtonAtBottom}
            HeaderButtons={HeaderButtons}
            ShowHeaderButtons={ShowHeaderButtons}
            ParentMenu={ParentMenu}
            showChildNav={ParentMenu?.ShowChildInNavigation || false}
          />
        )}
      </div>
    </>
  );
};
